export interface EnabledTool {
  name: string;
  enabled: boolean;
  url: string;
}

const HOSTNAME_QUERY_PARAM = 'hostname';

export const getFollowupEnabledToolsUrl = (enabledTools: EnabledTool[] | null | undefined): string | undefined => {
  const FOLLOWUP_TOOL_NAME = 'followup';
  const followupTool = enabledTools?.find((tool) => tool.name.toLowerCase() === FOLLOWUP_TOOL_NAME && tool.enabled);
  return followupTool?.url ?? undefined;
};

const getCalendarCrossUrl = (calendarCrossUrl: string, projectId?: string, eventId?: string): string => {
  if (!projectId) return `${calendarCrossUrl}/calendar`;
  const goToEventCreate = projectId && !eventId;
  return goToEventCreate ? `${calendarCrossUrl}/calendar-activity` : `${calendarCrossUrl}/calendar-activity/${projectId}/${eventId}`;
};

const getAccountManagerCrossUrl = (accountManagerCrossUrl: string, accountId?: string): string => {
  if (!accountId) return `${accountManagerCrossUrl}/account-manager`;
  return `${accountManagerCrossUrl}/account-profile/${accountId}`;
};

export const buildCrossUrl = ({
  toolUrl,
  projectId,
  id,
  module = 'calendar',
}: {
  toolUrl?: string;
  projectId?: string;
  id?: string;
  module?: 'calendar' | 'account-manager';
}): string => {
  if (!toolUrl) {
    return '';
  }
  try {
    const crossUrl = 'followup-v2';
    const calendarUrl = getCalendarCrossUrl(crossUrl, projectId, id);
    const accountManagerUrl = getAccountManagerCrossUrl(crossUrl, id);
    const url = new URL(toolUrl);
    const hostnameParam = url.searchParams.get(HOSTNAME_QUERY_PARAM);
    // remove eventual query string
    url.search = '';
    if (hostnameParam) {
      url.searchParams.set(HOSTNAME_QUERY_PARAM, hostnameParam);
    }
    // normalize pathname
    let pathname = url.pathname;
    // remove trailing slash
    if (pathname.endsWith('/')) {
      pathname = pathname.slice(0, -1);
    }
    // remove /followup final
    if (pathname.endsWith('/followup')) {
      pathname = pathname.replace(/\/followup$/, '');
    }
    // final reconstruction
    const finalPath = `${url.origin}${pathname}/${module === 'calendar' ? calendarUrl : accountManagerUrl}`;
    return `${finalPath}${url.search}`;
  } catch {
    throw new Error('Invalid URL provided');
  }
};
